import { Ref } from 'react';
import { IconProps } from '../Icon';
import { HelpPopupProps } from '../HelpPopup';
import { HighlightableTextProps } from '../../hooks/useHighlightableText';
import { OmitStrict } from '../../utility-types';
import { getLabelDesignTokens } from './Label';
import { NovaComponentProps } from '../../util/utility-types';

export enum LabelVariant {
  Standard = 'standard',
  PrimaryLight = 'primary-light',
}
export type TokensProp = null | (() => { fg?: string });

export interface LabelProps
  extends NovaComponentProps<keyof ReturnType<typeof getLabelDesignTokens>> {
  id?: string;
  children?: string;
  disabled?: boolean;
  required?: boolean;
  wrapText?: boolean;
  suppressTooltip?: boolean;
  htmlFor?: string;
  variant?: LabelVariant;
  icon?: Omit<IconProps, 'disabled' | 'focusable' | 'onClick' | 'onPress'>;
  /**
   * @deprecated use `theme` instead
   */
  tokens?: TokensProp;
  helpPopup?: HelpPopupProps;
  containerRef?: Ref<HTMLDivElement>;
  highlightableConfig?: OmitStrict<HighlightableTextProps, 'text'>;
}
